export const getPercentage = (total: number = 0, part: number = 0) => {
  const percentage = (part * 100) / total;
  return parseFloat(percentage.toFixed(2));
};
